import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { appSettings } from '../settings';
import { EEnvironments } from '../data/Constants';
import { version } from '../version';
import { useTranslation } from 'react-i18next';

import type { IBuildVersion } from '../../types/IComponentTypes';
/**
 * Renders the Footer which icludes the environment and version of the application .
 * @returns {JSX.Element} the Footer component
 */
const Footer = () => {
  const { t } = useTranslation();

  const color: { [index: string]: string } = {
    DEV: 'bg-yellow',
    TEST: 'bg-orange',
    ACC: 'bg-green',
    PROD: 'bg-gray',
  };

  const [value, setValue] = useState<IBuildVersion>();

  useEffect(() => {
    //Returns the version value of application
    setValue(version);
  }, []);

  if (appSettings.Environment === EEnvironments.PROD) {
    return null;
  }

  return (
    <Grid className={`footer ${color[appSettings.Environment]}`}>
      <span>
        {appSettings.Environment} | <b>{t('footer.release')}</b>: {value?.release} |
        <b>{t('footer.sprint')}</b>: {value?.sprint} | <b>{t('footer.build')}</b>: {value?.build} |{' '}
        <b>{t('footer.branch')}</b>: {value?.branch} | <b>{t('footer.date')}</b>: {value?.date}
      </span>
    </Grid>
  );
};

export default Footer;
